
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Bike, Store } from "lucide-react";

export const DeliveryToggle = ({ 
  value, 
  onValueChange,
  deliveryAvailable = true
}: { 
  value: string;
  onValueChange: (value: string) => void;
  deliveryAvailable?: boolean;
}) => {
  if (!deliveryAvailable) {
    return (
      <div className="bg-muted p-1 rounded-lg">
        <div className="flex items-center justify-center gap-2 text-sm font-medium p-2">
          <Store className="h-4 w-4" />
          Pickup only
        </div>
      </div>
    );
  }

  return (
    <div className="bg-muted p-1 rounded-lg">
      <ToggleGroup
        type="single"
        value={value}
        onValueChange={onValueChange}
        className="grid grid-cols-2 w-full"
      >
        <ToggleGroupItem 
          value="delivery" 
          className="flex items-center justify-center gap-2 rounded-md px-4 py-2 data-[state=on]:bg-white data-[state=on]:shadow-sm transition-all"
        >
          <Bike className="h-4 w-4" />
          Delivery
        </ToggleGroupItem>
        <ToggleGroupItem 
          value="pickup" 
          className="flex items-center justify-center gap-2 rounded-md px-4 py-2 data-[state=on]:bg-white data-[state=on]:shadow-sm transition-all"
        >
          <Store className="h-4 w-4" />
          Pickup
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
